import { WrongBrandError } from '../errors'
import { cgw } from '../lib'
import { Brand } from '../types'

export async function authenticateBrand({
  trackingId,
  cookies,
}: {
  trackingId: string
  cookies: string
}) {
  const { data: order } = await cgw.request<{ brand: Brand }>({
    method: 'GET',
    url: `/orders/by-tracking-id/${trackingId}/lazy`,
    params: { properties: 'brand' },
    headers: { Cookie: cookies },
  })

  // Block budbee orders
  if (order?.brand === 'budbee') {
    throw new WrongBrandError('Order not found')
  }

  return order.brand
}
